import { BorderBox } from '@/components/atoms/BorderBox';
import { useFieldFormContext } from '@/features/question/components/organisms/FieldForm';

export function NotFoundForm() {
    const { form } = useFieldFormContext();
    const field_type = form?.watch('field_type');

    return (
        <div className="mt-2">
            {(() => {
                if (!field_type) {
                    return (
                        <BorderBox variant='info' size='sm'>
                            Pick a field from the list above
                        </BorderBox>
                    )
                }

                return (
                    <BorderBox variant='danger' size='sm'>
                        The requested field is missing or no longer available. Please report this issue to us.
                    </BorderBox>
                )
            })()}
        </div>
    )
}